import { IResourceAssignment } from '../../interfaces/iresource-assignment';
import { Item } from '../item';
import { Project } from '../project';

export class ResourceAssignmentBase {
  ResourceAssignmentId: number;
  ItemId: number;
  ProjectId: number;
  Quantity: number;
  NeedByDate: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Item?: Item;
  Project?: Project;

  constructor(item?: IResourceAssignment) {
    if (item) {

      this.ResourceAssignmentId = item.ResourceAssignmentId;
      this.ItemId = item.ItemId;
      this.ProjectId = item.ProjectId;
      this.Quantity = item.Quantity;
      this.NeedByDate = item.NeedByDate ? new Date(item.NeedByDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Item = new Item(item.Item);
      this.Project = new Project(item.Project);
    }
  }
}